var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.563,
    height: 25.25,
    viewBox: "0 0 31.563 25.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.563,15.469,25.094,6H6.156A3.166,3.166,0,0,0,3,9.156V28.11a3.152,3.152,0,0,0,3.156,3.14l25.25-.016a3.152,3.152,0,0,0,3.156-3.14Zm-11.047-7.1,8.68,8.68h-8.68Z",
    transform: "translate(-3 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.5f8666b5b7bae79d9d9d75d5488ef9bf.svg";
export { ForwardRef as ReactComponent };